"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JSchema_1 = require("./JSchema");
exports.JsonSchema = JSchema_1.default;
var schemaMixin_1 = require("./schemaMixin");
exports.schemaMixin = schemaMixin_1.default;
var schemaMethods_1 = require("./schemaMethods");
exports.schemaMethods = schemaMethods_1.default;
var SchemaWrapper_1 = require("./SchemaWrapper");
exports.SchemaWrapper = SchemaWrapper_1.default;
// tslint:disable-next-line: no-var-requires
// const polyfills = require('./polyfills.ts');
var polyfills = require("./polyfills");
exports.polyfills = polyfills;
exports.default = JSchema_1.default;
//# sourceMappingURL=index.js.map